@if (colorable()) {
  <span class="icon-mask" [style.mask-image]="maskImageUrl()" aria-hidden="true"></span>
} @else {
  <img
    [ngSrc]="src()"
    [width]="resolvedWidth()"
    [height]="resolvedHeight()"
    [alt]="alt()"
    [attr.aria-hidden]="alt() ? null : true"
    [style.filter]="'var(--icon-filter, none)'"
    [style.transition]="'filter var(--transition-fast)'"
  />
}
